import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { infoPlayer } from '@app/app/pdp/pdp-model';
import { PDPService } from '@app/app/pdp/pdp/pdp.service';
import { DeviceService, EventTrackerService, HttpService } from '@app/core';
import { TokenService } from '@app/core/token/token.service';
import { NotificationService } from '@app/shared/notification/notification.service';
import { environment } from '@env/environment';
import { SwiperComponent } from 'ngx-useful-swiper';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SwiperOptions } from 'swiper';

import { SliderTypeEnum } from '../carousel/iCarousel';
import { PlayerService } from '../player/player.service';
import { NavigateMode } from './IBanner';

@Component({
  selector: "navaar-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"]
})
export class BannerComponent implements OnInit {
  @ViewChild('usefulSwiper', { static: false }) usefulSwiper: SwiperComponent;
  @Input() items: any;
  @Input("type-banner") public type: 'banner-slider' | 'banner';
  @Input("type-slider") public typeSlider: SliderTypeEnum = SliderTypeEnum.Normal;
  @Input("event-tracker-name") private eventName: string;
  @Input('index-banner') private indexBanner: number;
  public readonly BASE_HREF_IMAGE = environment.imageUrl;
  public configSliderNormal: SwiperOptions = {
    pagination: { el: ".swiper-pagination", clickable: true },
    spaceBetween: 0,
    autoplay: true,
    on: {
      slideChange: () => {
        const index = this.usefulSwiper.swiper.activeIndex;
      }
    }
  };
  public configBannerSlider: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 30,
  };
  public navigateMode: typeof NavigateMode = NavigateMode;
  public playInfo: infoPlayer | null = null;
  public sliderType: typeof SliderTypeEnum = SliderTypeEnum;

  constructor(
    private readonly notification: NotificationService,
    public readonly pdpService: PDPService,
    public readonly playerService: PlayerService,
    private readonly http: HttpService,
    public readonly tokenServices: TokenService,
    private readonly eventTracker: EventTrackerService,
    private readonly router: Router,
    public readonly device: DeviceService) { }
  ngOnInit(): void {
    if (this.items?.actionType === NavigateMode.Play) {
      this.http.post(`/api/library/info/${this.items.actionValue}`).subscribe(z => {
        this.playInfo = {
          audioBookId: z.audioBookId,
          title: z.title,
          image: `${environment.imageUrl}/content/books/${z.audioBookId}/pic.jpg?t=${z.recordVersion}`,
          isOwner: z.isOwner,
          identifier: z.identifier,
          contentType: z.contentType,
          author: z.authors[0] ? z.authors[0].firstName + ' ' + z.authors[0].lastName : '',
          narrators: z.narrators[0] ? z.narrators[0].firstName + ' ' + z.narrators[0].lastName : '',
          productId: z.productId
        }
      });
    }
  }

  public navigateToInternalUrl(link: string) {
    this.router.navigateByUrl(link);
  }

  public eventRegister(item, index) {
    this.eventTracker.logEvent(this.eventName, {
      item_type: this.type,
      item_index: index,
      item_image: item.imageUrl,
      item_title: item.title,
      x_item_navigate_mode: NavigateMode[item.navigateMode],
      x_item_navigate_target: item.navigateTarget,
      x_item_index: this.indexBanner
    });
  }

  public async play() {
    let isOwner: boolean = false;
    if (this.tokenServices.isLogin)
      isOwner = this.playInfo.isOwner;
    let allowPlay = true;
    let _isAdded = this.pdpService.getSoldBooks.has(this.playInfo.productId);
    if (_isAdded)
      isOwner = true;
    if (this.tokenServices.isLogin && !isOwner) {
      await this.http.post(`/api/orders/app-nopayment?productId=${this.playInfo.productId}`, {})
        .pipe(
          tap(() => {
            isOwner = true;
            this.pdpService.getSoldBooks.add(this.playInfo.productId);
          }),
          catchError((error) => {
            allowPlay = false;
            this.notification.setNotification({ text: 'افزودن به کتابخانه با مشکل مواجه گردید', type: 'error', timeout: 5000 });
            return of(error);
          })).toPromise();
    }
    if (!allowPlay) {
      this.pdpService.setStatusPlayButton(false);
      return;
    }
    this.playInfo.isOwner = isOwner;
    this.pdpService.play(this.playInfo);
  }

  public async playInSlider(item) {
    if (item?.navigateMode === NavigateMode.Play) {
      const z = await this.http.post(`/api/library/info/${item.navigateTarget}`).toPromise();
      const playInfo = {
        audioBookId: z.audioBookId,
        title: z.title,
        image: `${environment.imageUrl}/content/books/${z.audioBookId}/pic.jpg?t=${z.recordVersion}`,
        isOwner: z.isOwner,
        identifier: z.identifier,
        contentType: z.contentType,
        authors: z.authors[0] ? z.authors[0].firstName + ' ' + z.authors[0].lastName : '',
        narrators: z.narrators[0] ? z.narrators[0].firstName + ' ' + z.narrators[0].lastName : '',
        productId: z.productId
      }
      let isOwner: boolean = false;
      if (this.tokenServices.isLogin)
        isOwner = playInfo.isOwner;
      let allowPlay = true;
      let _isAdded = this.pdpService.getSoldBooks.has(playInfo.productId);
      if (_isAdded)
        isOwner = true;
      if (this.tokenServices.isLogin && !isOwner) {
        await this.http.post(`/api/orders/app-nopayment?productId=${playInfo.productId}`, {})
          .pipe(
            tap(() => {
              isOwner = true;
              this.pdpService.getSoldBooks.add(playInfo.productId);
            }),
            catchError((error) => {
              allowPlay = false;
              this.notification.setNotification({ text: 'افزودن به کتابخانه با مشکل مواجه گردید', type: 'error', timeout: 5000 });
              return of(error);
            })).toPromise();
      }
      if (!allowPlay) {
        this.pdpService.setStatusPlayButton(false);
        return;
      }
      playInfo.isOwner = isOwner;
      this.pdpService.play(playInfo);
    }
  }
}
